module.exports = __webpack_public_path__ + "img/3ds.3a4bd2cf.svg";